import { render, staticRenderFns } from "./1.vue?vue&type=template&id=84613d16&"
import script from "./1.vue?vue&type=script&lang=js&"
export * from "./1.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/vhosts/lifecheq/htdocs/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('84613d16')) {
      api.createRecord('84613d16', component.options)
    } else {
      api.reload('84613d16', component.options)
    }
    module.hot.accept("./1.vue?vue&type=template&id=84613d16&", function () {
      api.rerender('84613d16', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/js/views/Calculators/KeyPlan/Steps/1.vue"
export default component.exports